import * as z from 'zod/mini';

export const CustomerTravelplanRequestSchema = z.object({
  locale: z.string(),
  office_id: z.number(),
  department_id: z.number(),
  travelplan_id: z.union([z.number(), z.string()]),
});

const ParticipantSchema = z.object({
  main_booker: z.boolean(),
  id: z.number(),
  gender: z.nullish(z.string()),
  first_name: z.string(),
  last_name: z.string(),
  email: z.nullish(z.string()),
  phone: z.nullish(z.string()),
  birth_date: z.nullish(z.string()),
  address: z.nullish(z.object({
    street: z.string(),
    housenum: z.nullish(z.string()),
    address_line_2: z.nullish(z.string()),
    city: z.string(),
    state: z.nullish(z.string()),
    postal_code: z.string(),
    country: z.string(),
  })),
});

const MediaSchema = z.object({
  id: z.number(),
  description: z.nullish(z.string()),
  url: z.string(),
  file_type: z.string(),
  created_at: z.nullish(z.string()),
});

const ProductSchema = z.object({
  id: z.number(),
  name: z.string(),
  media: z.array(MediaSchema),
});

const LineSchema = z.object({
  id: z.number(),
  unit_name: z.string(),
  product: z.nullish(ProductSchema),
});

const OrderBlockSchema = z.object({
  id: z.number(),
  name: z.nullish(z.string()),
  start_date: z.string(),
  end_date: z.string(),
  lines: z.array(LineSchema),
});

export const CustomerTravelplanResponseSchema = z.object({
  id: z.union([z.number(), z.string()]),
  name: z.string(),
  start_date: z.nullish(z.string()),
  end_date: z.nullish(z.string()),
  pax: z.number(),
  participants: z.array(ParticipantSchema),
  order_blocks: z.array(OrderBlockSchema),
  guibo_identifier: z.nullish(z.string()),
  guibo_release_url: z.nullish(z.string()),
  is_paid: z.boolean(),
});
